import { AssemblerContentSchema } from './assembler.content.model.schema.js';
import { schemaWithoutProps } from '@database/common-schema/schemaWithoutProps';
/**
 * CA Article schema - schema of an article coming from CA API (before getting enriched by CTF data)
 */
export const CaArticleSchema = schemaWithoutProps({
    ...AssemblerContentSchema,
    title: 'ICaArticle',
}, ['linkedContentsRef', 'allowedBrands', 'partner'], []);
//# sourceMappingURL=ca.article.model.schema.js.map